import { render, staticRenderFns } from "./OtherWrapper.vue?vue&type=template&id=9eae93ba&"
import script from "./OtherWrapper.vue?vue&type=script&lang=ts&"
export * from "./OtherWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports